export const router_mantenimiento = [
    {
        path: 'procesos/lista',
        name: 'Procesos list',
        component: () => import('./lista')
    },    {
        path: 'lotes/lista',
        name: 'Lotes list',
        component: () => import('./listaLote')
    },{
        path: 'procesos/consultar/:id',
        name: 'Procesos consultar',
        component: () => import('./consultar')
    // },{
    //     path: 'procesos/resumen/:id',
    //     name: 'Procesos resumen',
    //     component: () => import('./resumen')
    },{
        path: 'procesos/actualizar/nueva',
        name: 'Procesos nueva',
        component: () => import('./actualizar')
    }, {
        path: 'procesos/actualizar/:id',
        name: 'Procesos actualizar',
        component: () => import('./actualizar')
    },{
        path: 'procesos/propuesta/:id',
        name: 'Propuesta de procesos',
        component: () => import('./process_proposal')
    },{
        path: 'procesos/actualizar/:id/lote/:idPlot',
        name: 'Propuesta de Ganadora',
        component: () => import('./proposalWinner')
    },{
        path: 'procesos/ofertar/:id',
        name: 'Propuesta por proceso',
        component: () => import('./offerPlot')
    }

    ,{
        path: '/process/offerPlotDetail/:id',
        name: 'Propuesta por empresa',
        component: () => import('./detailOfferPlot')
    }
    ,{
        path: '/procesos/mantenimiento/documentos',
        name: 'Mantenimiento de archivos',
        component: () => import('./ProcessFileCrud')
    }
]
